import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Box, Drawer, ListItem } from '@material-ui/core';
import { Field, Form } from 'react-final-form';
import { TextAreaComponent, DatePickerComponent, TextFieldWithSelectComponent, TextFieldComponent } from '../../components/FormElement';
import Button from '../../components/ButtonCustom';
import { portalCfg } from '../../../portal.router.config';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import {CheckIcon, ErrorIcon} from '../../components/icons'
import {Cancel} from '@material-ui/icons'
import Divider from '../../components/Divider'
import { getAppCfg } from '../../utils/common';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { custom_assets, domainName, portal_config } from '../../../portal.config';
import { isRetina } from '../../utils/util';
import CustomizedCircularProgress from '../../components/CircularProgress'
import validators from '../../utils/validators';
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
const redeemImg = isRetina(path+"/images/redeem_pass@2x.png", path+"/images/redeem_pass@3x.png")
    const styles = theme => ({
        form: {
            marginTop: theme.spacing(20),
            backgroundColor: theme.palette.background.box,
            padding: theme.spacing(8, 4, 8, 4),
            borderRadius: theme.spacing(4),
        },
        button: {
            marginTop: theme.spacing(8)
        },
        marginTop:{
            marginTop: theme.spacing(4)
        },
        marginTop20:{
            marginTop: theme.spacing(20)
        },
        form2:{
            padding: theme.spacing(4),
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(1.5),
            border: '1px solid',
            borderColor: theme.palette.border.transparent,
            backgroundColor: theme.palette.background.secondary,
            borderRadius: theme.spacing(4),
            boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        },
});

function RedeemPassView(props) {
        
    const { classes, t, onSubmit } = props
    const app_config = getAppCfg()
   
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={props.onClose}
                title = {t('redeem_pass')}
                children={
                    <Grid item >
                        <Grid xs={12} item container justify='center' className={classes.marginTop20}>
                            <img src={redeemImg} style={{width: 360}}/>
                        </Grid>

                        <Grid xs={12} item container justify='center'>
                            <CustomTypo mg_top_xl variant='body2' color='onPrimary' center>{t('redeem_desc')}{app_config.name ? app_config.name : portal_config[domainName].app_name}{t('refer_a_friend_desc2')}</CustomTypo>
                        </Grid>
                        <Form
                            onSubmit={onSubmit}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify='center' className={classes.form}>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="pass_code"
                                            component={TextFieldComponent}
                                            //label={t('first_name')}
                                            placeholder={t('pass_code')}
                                            isEdit={true}
                                            color='default'
                                            //onCustomChange={handleChange}
                                            validate={validators.composeValidators(validators.required)}
                                        />
                                    </Grid>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="pass_pin"
                                            component={TextFieldComponent}
                                            //label={t('first_name')}
                                            placeholder={t('pass_pin')}
                                            isEdit={true}
                                            color='default'
                                            //onCustomChange={handleChange}
                                            //validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                        />
                                    </Grid>
                                    <Grid xs={12} item container justify='center' className={classes.button}>
                                        <Button color='primary' fullWidth onClick={handleSubmit}>{t('redeem')}</Button>
                                    </Grid>
                                </Grid>
                            )} />  
                </Grid>}/>

        </div>
    )
}

export default withStyles(styles)(withTranslation()(RedeemPassView));